import React from 'react'
import CONSTS, { EXPLAIN_FAIL_WHILE_TRANSACTION_SUCCESS, EXPLAIN_PASS_WHILE_TRANSACTION_FAILED } from "shared/consts"
import web3 from "../utils/web3"
import { Chip } from "@material-ui/core"
import AddressDisplay from "./address-display"
import ParameterDisplay from "./parameter-display"
import CopyToClipboardComponent from '../utils/copy-to-clipboard'
import Byte32Display from './byte32-display'

export function StepResultTable({blockNumber=null,step,textOnly=null,store=null,showNames=true}) {
  var tableDefinition = [
    // {
    //   title:'Block #',
    //   hide:()=>true,
    //   value:(step,step_output) => {
    //     if(textOnly) return blockNumber
    //     var isNext=store.results.length-1>store.currentResult
    //     var isPrev=store.currentResult>0
    //     function Move({isRight}) {
    //       var enable=(isRight && isNext) || (!isRight && isPrev)
    //         return <span
    //           onClick={()=>{
    //             if (!enable) {
    //               return
    //             }
    //             store.currentResult+=isRight ? 1 : -1
    //             store.updateStore()
    //           }}
    //           style={{
    //             cursor:enable ? 'pointer' : 'default',
    //             opacity:enable ? 1 : 0.3,
    //             transform: isRight ? '' : 'scaleX(-1)',
    //             display:'inline-block',
    //           }}>
    //             ▶
    //           </span>
    //     }
    //     return <span><Move isRight={false}/> {blockNumber} <Move isRight/></span>
    //   }
    // },
    {
      title: "Result",
      value: (step, step_output) => {
        var stepText
        var isError
        if (step.skip) {
          stepText="Transaction Skipped"
          isError=true
        } else if (step_output.success && step_output.pass_expections===false) {
          stepText=EXPLAIN_FAIL_WHILE_TRANSACTION_SUCCESS
          isError=true
        } else if (!step_output.success && step_output.pass_expections) {
          stepText=EXPLAIN_PASS_WHILE_TRANSACTION_FAILED
          isError=false
        } else {
          stepText = step_output.success ? "✔︎ Transaction Success" : "Transaction Failed"
          isError=!step_output.success
        }
        if(textOnly) return stepText

        if(step.skip){
          //@ts-ignore
          return <Chip
            type="error"
            label={stepText}
            style={{ background: "orange", color: "#F6F6FA" }}
          />
        } else if(isError) {  
          //@ts-ignore 
          return <Chip
            type="error"
            label={stepText}
            style={{ background: "#B9251C", color: "#F6F6FA" }}
          />
        } else {
          //@ts-ignore
          return <Chip
            type="error"
            label={stepText}
            style={{ background: "#168736", color: "#F6F6FA" }}
          />
        }
      },
    },       
    // {
    //   title: "Block",
    //   value: (step,step_output) => {
    //     console.log({step_output})
    //     return blockNumber + ' (' + 
    //     require('moment')(step_output?.block?.timestamp*1000).format("DD MMM YYYY HH:mm:ss") + ')'
        
    //   },
    // },       
    // {
    //   title: "Tx",
    //   hide:(step)=>step.type!='ENCODE_TRANSACTION' && step.type!='COMPILE_SMART_CONTRACT',
    //   value: (step,step_output) => {
    //     console.log({step_output})
    //     return step_output.txHash
        
    //   },
    // },       
    {
      hide:true,
      title: "Title",
      // value:(step,step_output,index)=>{
      //   return step.
      // }
      value: (step) => {
        if(textOnly) return CONSTS.getStepNameByType(step.type,store.isDryRun)
        if (step.name)
          return (
            <div>
              {step.name}
              <br />({CONSTS.getStepNameByType(step.type,store.isDryRun)}
            </div>
          )
        else return CONSTS.getStepNameByType(step.type,store.isDryRun)
      },
    },    
    {
      title: "Sender",
      value: (step) => {
        if(textOnly) return step.from
        return <AddressDisplay address={(step.from)} showNames={showNames}/>
      },
      hide:step=>{
        if(step.skip) return true
        if(step.type=="ENCODE_TRANSACTION" && step.execute=="no") return true
        if(step.type==CONSTS.STEP_TYPES.ETHER_FUND) return true
        if(step.type==CONSTS.STEP_TYPES.CHECk_BALANCE) return true
        if(step.type==CONSTS.STEP_TYPES.CHECk_BALANCE) return true
        if(step.deploy=="no" || step.deploy=="abi") return true
        return false
      }
    },
    {
      title: "To",
      value: (step) => {
        if(textOnly) return step.to
        return <AddressDisplay address={step.to} showNames={showNames} />
      },
      hide:step=>{
        if(step.skip) return true
        if(step.type=="ENCODE_TRANSACTION" && step.execute=="no") return true
        if(step.deploy) return true
        return false
      }
    },    
    {
      title: "Ether",
      hideBasedOnOutput:(step_output) => {
        return  step_output.value!=0 &&  step_output.value!="0"
      },
      value: (step,step_output) => {
        if(textOnly) return step.value
        return <span style={{ whiteSpace: "nowrap" }}>{step.value || step.gwei || 0} {
        step_output.valueInDollar=="$0.00" || step_output.valueInDollar=="$NaN" ? "" :("(" +(step_output.valueInDollar || 0) + ")")
        }</span>
      },
      hide:step=>{
        if(step.skip) return true
        if(step.type=="ENCODE_TRANSACTION" && step.execute=="no") return true
        if(step.deploy=="no" || step.deploy=="abi") return true
        if(step.type==CONSTS.STEP_TYPES.CHECk_BALANCE) return true
        return false
      }
    },
    {
      title: "Gas",
      hideBasedOnOutput:(step_output) => {
        return  step_output.value!=0 &&  step_output.value!="0"
      },
      value: (step, step_output) => {
        //@ts-ignore
        var gasUsed = parseInt("0x" + step_output?.receipt?.gasUsed)
        if (isNaN(gasUsed)) return "0"
        return formatNumberCommas(gasUsed) + ' (' + gasFee(step_output) + ')'
      },
      hide:step=>{
        if(step.skip) return true
        return false
      }
    },
    {
      title: "Arguments",
      hide:step=>{
        if(step.skip) return true
        // if(step.type=="ENCODE_TRANSACTION" && step.execute=="no") return true
        if(step.type!=CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT) return true
        if(!step.parameters) return true
        if(step.parameters.length==0) return true
        return false
      },
      value: (step) => {        
        var title, parameters, thisABI        
        // return JSON.stringify(step.parameters)
        var ABI=step.abi
        thisABI = ABI?.find(field => field.signature == "constructor")
        if(!thisABI) return
        var decoded=decodeToJSX(thisABI.inputs,step.parameters)
        if(textOnly) return title + ' (' +  decoded + ')'           
        return decoded
      },
    },    
    {
      title: "Function",
      hide:step=>{
        if(step.skip) return true
        // if(step.type=="ENCODE_TRANSACTION" && step.execute=="no") return true
        if(step.type!=CONSTS.STEP_TYPES.ENCODE_TRANSACTION) return true
        return false
      },
      value: (step) => {        
        var title, parameters, thisABI        
        var ABI=step.abi
        thisABI = ABI?.find(field => field.signature == step.function_signature)
        if(!thisABI) return
        var decoded=decodeToJSX(thisABI.inputs,step.data?.slice(4*2+2))
        if(textOnly) return title + ' (' +  decoded + ')'           
        return <div style={{whiteSpace:'nowrap'}}><b>{step.function_name}</b><br/>{decodeToJSX(thisABI.inputs,step.data?.slice(4*2+2), false, true)}</div>        
      },
    },    
    {
      title: "Logs",
      value: (step, step_output) => {
        if (step_output?.logs?.length>0)
          return step_output.logs.map((log,index,all) => {
            if(textOnly) return log.name + ' (' + mapLogParams(log).join(',') + ')'
            return (
              <div style={{
                whiteSpace:'nowrap'
              }}>
                <span style={{ fontWeight: "bolder" }}>{log.name}</span>
                <br/>
                        <span><span
                        style={{
                          color: "#747480",
                          whiteSpace:'nowrap',
                          fontSize: 14,
                        }}
                      >Log Topic=</span><b><AddressDisplay address={log.logAddress} showNames={true}/></b>
                      </span>
                {mapLogParams(log)}
                {index<all.length-1 && <br/>}
              </div>
            )
          })
        return 'None'
      },
      hide:step=>{
        if(step.skip) return true
        if(step.type=="ENCODE_TRANSACTION" && step.execute=="no") return true
        if(step.type==CONSTS.STEP_TYPES.ETHER_FUND) return true
        if(step.type==CONSTS.STEP_TYPES.CHECk_BALANCE) return true
        if(step.deploy=="no" || step.deploy=="abi") return true
        return false
      }
    },
    // {
    //   title: "Data",
    //   value: (step) => {
    //     if(textOnly) return step.data
    //     return <AddressDisplay address={step.data} />
    //   },
    //   hide:step=>{
    //     if(step.type!="ENCODE_TRANSACTION") return true
    //   }
    // },   
    {
      title: "Expected Output",
      hide:step=>!step.has_expected_output,
      value: (step, step_output) => {
        if(step.type=="CHECk_BALANCE") {
          return (step.expected_output?.[0] || 0) + ' Ether'
        }
        var thisABI = step?.abi?.find(field => field.signature == step.function_signature)
        if(!thisABI) return;
        return arrayToJSX(thisABI.outputs,step.expected_output);
      }
    } ,
    {
      title: "Expected Events",
      hide:step=>!step?.has_expected_events,
      value: (step, step_output) => {
        return step.expected_events.filter(x=>x.signature).map((event,index)=>{
          var eventABI = step?.abi?.find(field => field.signature == event.signature);
          // if(textOnly) return log.name + ' (' + mapLogParams(log).join(',') + ')'
            return (
              <div style={{
                whiteSpace:'nowrap'
              }}>
                <span style={{ fontWeight: "bolder" }}>{eventABI?.name || event.signature}</span>
                {eventABI && decodeToJSX(eventABI.inputs,event.expectedEventParameters)}
                {index<step.expected_events.length-1 && <br/>}
                </div>
          )})
      }
    },
    {
      title: "Output",
      value: (step, step_output) => {     
        if(step.type=="CHECk_BALANCE") {
          return step_output.result
        }
        if(step_output?.result=="Block doesn't exist.") {
          return "Block doesn't exist."
        }
        if(!step_output.receipt) {
          return ''
        }
        else if(step_output.receipt.createdAddress &&!step_output.receipt.exception) {
            return "Contract Created"
        }

        if(!step_output.receipt.exception && step_output.receipt.data) {
          // try parse by function_abi
          // this function
          var outputs=step?.abi?.find(x=>x.signature==step.function_signature)?.outputs
          if(!outputs) return
          if(step_output.receipt.data=='0x') {
            return "No output"
          }
          // console.log('output',{outputs},step_output.receipt.data)
          return decodeToJSX(outputs,step_output.receipt.data, false, true)          
        }

        //@ts-ignore
        var stepResultDescription
        if (step_output.detailed_result) {
          return step_output.detailed_result
        }
        if (step_output.receipt?.exception) {
          //@ts-ignore
          const errorMessage = step_output.receipt.returnValue ? `: ${step_output.receipt.returnValue}` : ""
          stepResultDescription = `Exception '${step_output.receipt.exception}'${errorMessage}`
        } else {
          stepResultDescription = step_output.result || "Transaction failed"
        }

        return stepResultDescription
      },      
      hide:step=>{
        if(step.skip) return true
        return false
      }
    },
  ]

  if(!textOnly) {
  tableDefinition=tableDefinition.filter(t => {
      //@ts-ignore
      if(t.hide===true) return false
      else if(!t.hide) return true
      else return !t.hide(step)
    })
  }
  return tableDefinition

  function formatNumberCommas(s) {
    if(textOnly) return s
    s = String(s)
    var n = ""
    for (var i = 0; i < s.length; i++) {
      n = s[s.length - 1 - i] + n
      if ((i + 1) % 3 == 0 && i < s.length - 1) n = "," + n
    }
    return n
  }
  function arrayToJSX(outputsOrInputs, decoded) {
    var max_uint_length=78;
    var res=[]
    for(var i=0;i<decoded.length;i++) {
      var name = outputsOrInputs?.[i]?.name
      var type = outputsOrInputs?.[i]?.type
      var value=decoded[i]
      if(textOnly) {
        res.push((name ? (name +'=') : '') + value)
      } else {
        res.push(
          <div>
            <span key={i}>{name && (name + '=')}</span>
            <b style={{ color: "#000" }}>
              {
                (type=="address" ||
                type!="address" && String(value).length>max_uint_length)
                  && 
                <AddressDisplay address={value} showNames={showNames}/>
              }
              {
                (type!="address" &&
                  String(value).length<=max_uint_length)
                  && 
                value
              }
              {value===true && "true"}
              {value===false && "false"}
              {value===0 && "0"}
              {value==='' && "No Output"}
              {value==='0x' && "No Output"}
              </b>
              &nbsp;
          </div>
        )
      }
    }
  if(textOnly) {
    return res.join(', ')
  } else {
    return res
  }
  }
  function decodeToJSX(outputsOrInputs, dataOrParameters, textOnly = false, showNames = false) {
    try {
      let decoded;
      if (Array.isArray(dataOrParameters)) {
        decoded = dataOrParameters;
      } else {
        decoded = web3.eth.abi.decodeParameters(outputsOrInputs, dataOrParameters);
      }
  
      let res = [];
      for (let i = 0; i < (decoded.__length__ || decoded.length); i++) {
        let name = outputsOrInputs[i].name;
        let type = outputsOrInputs[i].type;
        let value = decoded[i];
  
        res.push(PlainValueToString(i, type, name, value, textOnly, outputsOrInputs[i].components, showNames));
      }
  
      if (textOnly) {
        return res.join(', ');
      } else {
        return res;
      }
    } catch (err) {
      console.log("some error has occurred while decoding parameters", { outputsOrInputs, dataOrParameters }, err);
      return null;
    }
  }
  
  function PlainValueToString(i, type, name, value, textOnly, components, showNames = false) {
    var max_uint_length = 78;

    // Handling struct-like components
    if (components) {
      if (type.match(/\[/)) { // Array type
        var newType = type.replace(/\[.*/, '');
        if (textOnly) {
          return value.map((val, index) => `#${index}=${PlainValueToString(index, newType, String(index), val, textOnly, components, showNames)}`).join(',\n');
        }
        return (
          <table>
            {value.map((val, index) => <tr key={index}>
              <td valign='top'>#{index}</td>
              <td>
                {PlainValueToString(index, newType, String(index), val, textOnly, components, showNames)}
              </td>
            </tr>)}
          </table>
        );
      } else { // Non-array type
        if (textOnly) {
          return components.map((comp, index) =>
            PlainValueToString(index, comp.type, comp.name, value[index], textOnly, comp.components, showNames)
          ).join(',\n');
        }
        return components.map((comp, index) => <div key={index}>
          {PlainValueToString(index, comp.type, comp.name, value[index], textOnly, comp.components, showNames)}
        </div>);
      }
    }
  
    if (Array.isArray(value)) {
      console.log('isArray');
    }
  
    const StringValue = String(value);

    // Text-only output case
    if (textOnly) {
      return ((name ? (name + '=') : '') + StringValue);
    } else {
      return (
      <div key={i}>
        {name && <span>{name}=</span>}
        <b style={{ color: "#000" }}>
          {
            // Address handling
            (type === "address" ||
              (type !== "address" && StringValue.length > max_uint_length)) ?
                <AddressDisplay address={value} showNames={showNames} /> :
                // Byte32 handling
                (type === "bytes32") ?
                  <Byte32Display byte32={value}/> :
                  <>
                    {/* Explicit boolean handling */}
                    {typeof value === 'boolean' ? (value ? "true" : "false") : StringValue}
                    {value && <CopyToClipboardComponent text={StringValue} />}
                  </>
          }
          {/* Other specific values */}
          {value === 0 && "0"}
          {value === '' && "No Output"}
          {value === '0x' && "No Output"}
        </b>
        &nbsp;
      </div>
      );
    }
  }
  

  function mapLogParams(log) {
    const { parameters, parameterTypes } = log;
    return parameterTypes?.map((param, index, list) => {
      var name = param.name;
      var type = param.type;
      var value = parameters[index];
  
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
  
      if (textOnly) return name + '=' + value;
  
      return (
        <div
          style={{
            color: "#747480",
            whiteSpace: 'nowrap',
            fontSize: 14,
          }}
        >
          {name}=
          <b style={{ color: "#000" }}>
            {
              // Byte32 handling
              (type === "bytes32") ?
              <Byte32Display byte32={value}/>  :
                // Address handling
                (type === "address" ||
                  (type !== "address" && String(value).length > 10)) ?
                    <AddressDisplay address={value} showNames={showNames} /> :
                    value
            }
          </b>
        </div>
      );
    });
  }
  
  

  function getFunctionABI(function_signature) {
    return step.abi?.find(x=>x.signature==function_signature)
  }

  function gasFee(step_output){
    var gfa=getFunctionABI(step.function_signature)
    if(gfa?.stateMutability=="view" ||  gfa?.constant==true) return "Free"
    return  step_output?.gasFee
  }
}

